import { Transaction } from '@repo/common-types';

// Helper function to calculate deposit status
export const getDepositStatus = (inboundTx: Transaction, outboundTx: Transaction | null | undefined) => {
  if (inboundTx.status === 'CONFIRMED' && outboundTx?.status === 'CONFIRMED') {
    return 'CONFIRMED';
  }

  if (inboundTx.status === 'CONFIRMED' && outboundTx?.status === 'PENDING') {
    return 'PENDING';
  }

  if (inboundTx.status === 'FAILED') {
    return 'FAILED';
  }

  return 'PENDING';
};
